import constants from "@/constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const newConstants = (constants as unknown) as Constants;

import { Buffer } from "buffer";

const encodeBase64 = (data: string) => {
  return Buffer.from(data).toString("base64");
};
const decodeBase64 = (data: string) => {
  return Buffer.from(String(data), "base64").toString("ascii");
};
const getBrowserIdentity = () => {
  return `${String(
    parseInt(String(new Date().getMinutes() / 3))
  )}${encodeBase64(navigator.userAgent).substring(0, 10)}`;
};
const revertStr = (data: string) => {
  return String(data)
    .split("")
    .reverse()
    .join("");
};

export default {
  checkErrorMsg(err: string): string {
    if (newConstants?.[err]) return newConstants[err];
    return constants.CONN_ERROR;
  },
  onlyNumbers(value: string): string {
    return String(value).replace(/\D+/g, "");
  },
  formatCellphone(value: string | number): string {
    return (
      String(value || "")?.replace(
        /([0-9]{2})([0-9]{1})([0-9]{4})([0-9]{4})/,
        "($1) $2 $3-$4"
      ) || ""
    );
  },
  validateCNPJ(cnpj: string | number): boolean {
    cnpj = String(cnpj).replace(/[^\d]+/g, "");

    if (!cnpj || cnpj === "" || cnpj.length !== 14) {
      return false;
    }

    if (
      cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999"
    ) {
      return false;
    }

    let tamanho = cnpj.length - 2;
    const digitos = cnpj.substring(tamanho);
    let numeros = cnpj.substring(0, tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = String(soma % 11 < 2 ? 0 : 11 - (soma % 11));

    if (resultado !== digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = String(soma % 11 < 2 ? 0 : 11 - (soma % 11));

    if (resultado !== digitos.charAt(1)) {
      return false;
    }

    return true;
  },
  validateCPF(cpf: string): boolean {
    function calcChecker1(firstNineDigits = ""): number {
      let sum = 0;
      for (let j = 0; j < 9; ++j) {
        sum += parseInt(firstNineDigits.toString().charAt(j)) * (10 - j);
      }
      const lastSumChecker1 = sum % 11;
      return lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;
    }
    function calcChecker2(cpfWithChecker1 = ""): number {
      let sum = 0;
      for (let k = 0; k < 10; ++k) {
        sum += parseInt(cpfWithChecker1.toString().charAt(k)) * (11 - k);
      }
      const lastSumChecker2 = sum % 11;
      return lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;
    }

    const cleanCPF = String(cpf).replace(/[^\d]/g, "");
    const firstNineDigits = cleanCPF.substring(0, 9);
    const checker = cleanCPF.substring(9, 11);

    for (let i = 0; i < 10; i++) {
      if (firstNineDigits + checker === Array(12).join(String(i))) {
        return false;
      }
    }

    const checker1 = calcChecker1(firstNineDigits);
    const checker2 = calcChecker2(`${firstNineDigits}${checker1}`);

    if (checker.toString() === checker1.toString() + checker2.toString()) {
      return true;
    }

    return false;
  },
  validatePassword(password = ""): boolean {
    return /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/.test(String(password || ""));
  },
  formatCNPJ(cnpj: string | number): string {
    return String(cnpj || "")
      .replace(/\D/g, "")
      .replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
  },
  validateCorporativeEmail(email = ""): boolean {
    email = String(email || "").trim();

    const emailList = [
      "@gmail.",
      "@zohomail.",
      "@hotmail.",
      "@outlook.",
      "@icloud.",
      "@fastmail.",
      "@protonmail.",
      "tempemailco",
      "@lmomentsf.",
      "@owlymail.",
      "@mailcupp.",
      "@gurumail.",
      "@lifewire.",
      "@senduvu.",
      "@mywrld.",
      "@toracw.",
      "@reqaxv.",
      "@zaelmo.",
      "@wootap.",
      "@mailsy.",
      "@ttirv.",
      "@yahoo.",
      "@msn.",
      "@bol.",
      "@aol.",
      "@aim.",
      "@gmx."
    ];

    let validEmail = true;
    for (let index = 0; index < emailList.length; index++) {
      const str = emailList[index];
      if (email.indexOf(str) > 0) {
        validEmail = false;
        break;
      }
    }

    return validEmail;
  },
  validEmail(email = ""): boolean {
    return /.+@.+\..+/.test(email);
  },
  validUrl(url = ""): boolean {
    return /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g.test(
      url
    );
  },
  dateDiff(date1?: string, date2?: string): number {
    const d1 = dayjs(date1 || dayjs());
    const d2 = dayjs(date2 || dayjs());

    return d1.diff(d2, "days") || 0;
  },
  dateGreater(date1?: string, date2?: string): boolean {
    const d1 = dayjs(date1 || dayjs());
    const d2 = dayjs(date2 || dayjs());
    return d1.isBefore(d2) || d1.isSame(d2);
  },
  maskEmail(email = ""): string {
    if (email) {
      const [user, domain] = email.split("@");
      const replaceLength = user.length || 1;
      const [first = "", last = ""] =
        replaceLength > 2 ? [user[0], user[replaceLength - 1]] : [user[0], ""];

      const replace = "*".repeat(replaceLength);
      return `${first}${replace}${last}@${domain}`;
    }

    return "";
  },
  formatMoneyBR(value: number): string {
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2
    });

    const formatted = formatter.format(value || 0);
    if (value < 0) {
      return "R$ -" + formatted.replace("-R$", " ").trim();
    }

    return formatted;
  },
  formatMoney(value: number): string {
    const formatter = new Intl.NumberFormat("pt-BR");
    return formatter.format(value || 0);
  },
  formatNumber(value: number): string {
    const formatter = new Intl.NumberFormat("pt-BR");
    return formatter.format(value || 0);
  },
  formatNumberInt(value: string): string {
    const formatter = new Intl.NumberFormat("pt-BR");
    return formatter.format(parseInt(value) || 0);
  },
  firstLetter(value: string): string {
    return ((value && value[0]) || "").toLocaleUpperCase();
  },
  formatDateUTC(date = ""): string {
    return dayjs(date || new Date())
      .utc(true)
      .format();
  },
  formatDate(date: string): string {
    if (!date) return "";
    return dayjs(date).format("DD/MM/YYYY");
  },
  formatDateTime(date = "", format?: string): string {
    return dayjs(date || new Date()).format(format || "DD/MM/YY HH:mm");
  },
  validBRDate(date = ""): boolean {
    const [day = "1", month = "1", year = "2050"] = date?.split("/") || [];
    return date === dayjs(`${year}-${month}-${day}`).format("DD/MM/YYYY");
  },
  getYears(date = ""): number {
    const [day = "1", month = "1", year = "2050"] = date?.split("/") || [];
    const d = dayjs(`${year}-${month}-${day}`);
    return dayjs(new Date()).diff(dayjs(d), "years");
  },
  formatDateTimeFull(date: string): string {
    if (!date) return "";
    return dayjs(date).format("DD/MM/YYYY HH:mm:ss");
  },
  removeDiacritics(value = ""): string {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  },
  generateURL(value = ""): string {
    return this.removeDiacritics(value || "")
      .toLocaleLowerCase()
      .replace(/[^a-z0-9 -]/g, "-")
      .replace(/\s+|-+/g, "-");
  },
  validateCreditCard(number = ""): boolean {
    const tmp = this.onlyNumbers(number || "") || "";

    if (!tmp || tmp.length < 14) return false;
    if (tmp.length === 19) return true;

    // The Luhn Algorithm
    let nCheck = 0;
    let nDigit = 0;
    let bEven = false;

    for (let n = tmp.length - 1; n >= 0; n--) {
      const cDigit = tmp.charAt(n);
      nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 == 0;
  },
  getUniques(itemList: UnknownObj[]): UnknownObj[] {
    const uniqueList: UnknownObj = {};

    return [...(itemList || [])]
      .map((item: UnknownObj) => {
        const itemId = item.id || "";
        if (itemId) {
          uniqueList[itemId] = true;
        }

        return {
          text: this.removeDiacritics(item?.name || item?.text),
          ...item
        } as UnknownObj;
      })
      .filter((item: UnknownObj) => {
        const itemId = item.id || "";
        if (uniqueList[itemId]) {
          uniqueList[itemId] = false;
          return true;
        }

        return false;
      });
  },
  campaingsStatus(status: string): string {
    status = String(status).toUpperCase();
    return newConstants.STATUS_TEXT[status] || "Outros";
  },
  campaingsStatusGroup(status: string): string {
    status = String(status).toUpperCase();
    return newConstants.STATUS_TEXT[status] || "Outros";
  },
  campaingsByStatus(campaigns: Campaign[], status: string): Campaign[] {
    return (campaigns || []).filter(campaign => campaign.status === status);
  },
  campaingDefaults(campaign: Campaign = {}): Campaign {
    const updatedCampaign = { ...campaign };

    updatedCampaign.durations = updatedCampaign.durations || [];
    updatedCampaign.formats = updatedCampaign.formats || [];
    updatedCampaign.gender = updatedCampaign.gender || [];
    updatedCampaign.days = updatedCampaign.days || [];
    updatedCampaign.times = updatedCampaign.times || [];
    updatedCampaign.locations = updatedCampaign.locations || [];
    updatedCampaign.initialAge = updatedCampaign.initialAge || 1;
    updatedCampaign.finishAge = updatedCampaign.finishAge || 100;
    updatedCampaign.socialClass = updatedCampaign.socialClass || [];

    return updatedCampaign;
  },
  encode(data: string) {
    // encode a string
    const id = getBrowserIdentity();
    return encodeBase64(
      `${id}${revertStr(encodeBase64(String(data)))}${revertStr(id)}`
    );
  },
  decode(data: string) {
    // decode the string
    try {
      const id = getBrowserIdentity();
      const decoded = decodeBase64(
        revertStr(
          decodeBase64(String(data))
            .replace(id, "")
            .replace(revertStr(id), "")
        )
      );
      return decoded;
    } catch (err) {
      return "";
    }
  }
};
